import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import is from 'is_js';
import { List, Map } from 'immutable';
import { Form, PageCard, SolidRadio, connect, testClass } from 'omni-common-ui';
import CardActionIcons from 'components/CardActionIcons';
import CardActionButtons from 'components/CardActionButtons';
import TextInput from 'components/TextInput';
import { actions as studyPlanActions } from 'data/IndividualDevelopmentPlans/StudyPlan';
import { Modes } from '../routes';
import { getMonthName } from 'domain/Month';

const SHOW_STUDY_PLAN = false;

class StudyPlan extends PureComponent {

  constructor(props) {
    super(props);
    this._onEditClick = this._onEditClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this._onDiscardClick = this._onDiscardClick.bind(this);
    this._onRadioClick = this._onRadioClick.bind(this);
    this.shouldDisableSaveButton = this.shouldDisableSaveButton.bind(this);
    this.setWasEditMade = this.setWasEditMade.bind(this);
    this.wasEditMade = this.wasEditMade.bind(this);
    this.state = { wasEditMade: false };
  }

  componentDidMount() {
    const {
      fetchStudyPlanCourseIfNeeded,
      fetchStudyPlanIfNeeded,
      idpId,
    } = this.props;
    fetchStudyPlanCourseIfNeeded(idpId);
    fetchStudyPlanIfNeeded(idpId);
    this.props.onComponentMounted(this);
    this._onStudyPlanResultUpdate(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._onStudyPlanResultUpdate(nextProps);
  }

  _getMonth(end) {
    return end.date() <= 15 ? end.month() : end.month() + 1;
  }

  _getStudyPlanItem(studyPlan, index, itemName) {
    if (List.isList(studyPlan) && is.existy(studyPlan.get(index))) {
      return studyPlan.get(index)[itemName];
    }
  }

  _getStudyPlan(studyPlan, period, month) {
    return new List([...Array(period).keys()].map((index) => ({
      sequence: index,
      coreCourseId: this._getStudyPlanItem(studyPlan, index, 'coreCourseId'),
      nonCoreCourseId: this._getStudyPlanItem(studyPlan, index, 'nonCoreCourseId'),
      otherOptions: this._getStudyPlanItem(studyPlan, index, 'otherOptions'),
      month: this._getMonth(month) + index,
    })));
  }

  _onStudyPlanResultUpdate(props) {
    if (this.wasEditMade()) return;
    const studyPlan = props.studyPlan && props.studyPlan.get('result');
    const period = List.isList(studyPlan) && studyPlan.size > 0 ? studyPlan.size : 6;
    const end = props.studentInfo.period.end;
    this.setState({
      period,
      isStudyPlanInited: false,
      studyPlan: this._getStudyPlan(studyPlan, period, end),
    });
  }

  _onEditClick() {
    this.props.changeMode(Modes.EDIT_STUDY_PLAN);
  }

  onSaveClick() {
    const { idpId, groupIdpId, publishStudyPlan } = this.props;
    const studyPlan = this.state.studyPlan.toArray().map((plan) => ({
      coreCourseId: plan.coreCourseId,
      nonCoreCourseId: plan.nonCoreCourseId,
      otherOptions: is.undefined(plan.otherOptions) ?
        undefined : (plan.otherOptions.trim() || undefined),
      sequence: plan.sequence,
    }));
    publishStudyPlan(idpId, studyPlan, groupIdpId)
      .then(() => this._onDiscardClick());
  }

  _onDiscardClick(props = this.props) {
    this.setWasEditMade(false);
    props.changeMode('');
    this._onStudyPlanResultUpdate(props);
  }

  _onRadioClick() {
    const period = this.state.period === 6 ? 12 : 6;
    const end = this.props.studentInfo.period.end;
    this.setState({
      period,
      isStudyPlanInited: false,
      studyPlan: this._getStudyPlan(this.state.studyPlan, period, end),
    });
  }

  _onContentChange(sequence, val, itemName) {
    const { studyPlan } = this.state;
    const index = studyPlan.findIndex((plan) => plan.sequence === sequence);
    const result = studyPlan.update(index, (plan) => Object.assign(
      {},
      plan, {
        [itemName]: val || undefined,
      }));
    this.setState({
      studyPlan: result,
    });
    this.setWasEditMade(true);
  }

  _isEditing() {
    return this.props.isInEditMode;
  }

  _renderButtons() {
    if (! this._isEditing()) {
      return null;
    }
    return <CardActionButtons className={styles.StudyPlan_buttons}
        isPrimaryDisabled={this.shouldDisableSaveButton()}
        onPrimaryClick={this.onSaveClick}
        onSecondaryClick={this._onDiscardClick} />;
  }

  shouldDisableSaveButton() {
    const { studyPlan } = this.state;
    return ! (List.isList(studyPlan) && studyPlan.filter((plan) =>
        is.existy(plan.coreCourseId)).size > 0);
  }

  setWasEditMade(wasEditMade) {
    if (is.not.boolean(wasEditMade)) return;
    this.setState({ wasEditMade });
  }

  wasEditMade() {
    return this.props.isInEditMode && this.state.wasEditMade;
  }

  _renderContent() {
    return <div>{this._renderTable()}</div>;
  }

  _renderRadio() {
    if (! this._isEditing()) {
      return null;
    }
    return <div className={styles.StudyPlan_radio}>
      <div className={styles.StudyPlan_radio_item}>
        <SolidRadio name="period"
            id="6"
            value="6"
            isChecked={this.state.period === 6}
            onChange={this._onRadioClick} />
        6 months
      </div>
      <div className={styles.StudyPlan_radio_item}>
        <SolidRadio name="period"
            id="12"
            value="12"
            isChecked={this.state.period === 12}
            onChange={this._onRadioClick} />
        12 months
     </div>
    </div>;
  }

  _renderRow(row) {
    return <li key={row.month}>
      <ul className={styles.StudyPlan_table_row}>
        <li>{getMonthName(row.month)}</li>
        <li>{this._renderCourse(row, 'coreCourses')}</li>
        <li>{this._renderCourse(row, 'nonCoreCourses')}</li>
        <li>{this._renderOtherOptions(row)}</li>
      </ul>
    </li>;
  }

  _renderCourse(row, itemName) {
    const idName = itemName === 'coreCourses' ?
      'coreCourseId' : 'nonCoreCourseId';
    if (! Map.isMap(this.props.studyPlan) ||
      ! List.isList(this.props.studyPlan.get(itemName))) {
      return null;
    }
    const courses = this.props.studyPlan.get(itemName);
    const courseId = row[idName];
    if (! this._isEditing()) {
      if (is.number(courseId) && courseId > 0) {
        const currentCourse = courses.find((course) => course.id === courseId);
        const label = currentCourse && currentCourse.name;
        return <span>{label || '-'}</span>;
      }
      return <span>-</span>;
    }
    const options = courses.toArray()
      .filter((course) => !! course.isActive)
      .sort((c1, c2) => c1.displayOrder - c2.displayOrder)
      .map((course) => ({
        label: course.name,
        value: course.id,
      }));
    options.splice(0, 0, {
      label: ' ',
      value: null,
      className: styles.StudyPlan_select_option,
    });
    return <Form.Select options={options}
        className={styles.StudyPlan_table_row_select}
        value={courseId}
        name="coreCourse"
        setValue={(val) => this._onContentChange(row.sequence, val, idName)}
        clearable={false}
        searchable={false} />;
  }

  _renderOtherOptions(row) {
    if (this._isEditing()) {
      return <TextInput className={styles.StudyPlan_table_row_input}
          value={row.otherOptions}
          maxLength={100}
          onChange={(e) => this._onContentChange(row.sequence, e.target.value, 'otherOptions')} />;
    }

    return <span>{row.otherOptions || '-'}</span>;
  }

  _renderTable() {
    return <ul className={styles.StudyPlan_table}>
      <li>
        <ul className={classnames(styles.StudyPlan_table_header,
            styles.StudyPlan_table_row)}>
          <li />
          <li>Core Course</li>
          <li>Non-Core Course (optional)</li>
          <li>Other Options</li>
        </ul>
      </li>
      {
        this.state.studyPlan.map((row) => this._renderRow(row))
      }
    </ul>;
  }

  _GenerateByDefault() {
    if (this._isEditing() &&
      ! this.wasEditMade() &&
      ! this.state.isStudyPlanInited &&
      is.existy(this.props.studyPlan) &&
      is.existy(this.props.studyPlan.get('coreCourses')) &&
      is.existy(this.props.studyPlan.get('result')) &&
      this.props.studyPlan.get('result').size === 0 &&
      this.state.studyPlan.size > 0) {
      const idpPeriod = this.props.studentInfo.period;
      const group = this.props.group;
      const groupPeriod = group.period;
      const courseType = group.groupSummary.courseTypeName;
      const courses = this.props.studyPlan.get('coreCourses');
      const currentCoreCourses = courses
        .filter((course) => course.name.startsWith(courseType))
        .sortBy((course) => course.displayOrder)
        .delete(0);
      const groupDays = groupPeriod.end.diff(groupPeriod.start, 'days');
      let remainingDays = groupPeriod.end.diff(idpPeriod.end, 'days');
      remainingDays = remainingDays < 0 ? 0 : remainingDays;
      const groupDuration = Math.ceil(groupDays / 30.0);
      const remainingDuration = Math.ceil(remainingDays / 30.0);
      let initedStudyPlan = new List();
      this.state.studyPlan.map((sp) => {
        let coreCourseId = sp.coreCourseId;
        if (remainingDuration > 0 && sp.sequence < remainingDuration) {
          coreCourseId = courses.first().id;
        } else {
          const index = ((sp.sequence - remainingDuration) / groupDuration);
          if (index < currentCoreCourses.size) {
            coreCourseId = currentCoreCourses.get(index).id;
          }
        }
        initedStudyPlan = initedStudyPlan.push({
          sequence: sp.sequence,
          coreCourseId,
          nonCoreCourseId: sp.nonCoreCourseId,
          otherOptions: sp.otherOptions,
          month: sp.month,
        });
        return 0;
      });
      this.setState({
        isStudyPlanInited: true,
        studyPlan: initedStudyPlan,
      });
    }
  }

  render() {
    if (! this.state || ! is.existy(this.state.studyPlan)) {
      return null;
    }

    this._GenerateByDefault();

    return SHOW_STUDY_PLAN && <PageCard className={testClass('study-plan')}>
      <PageCard.Heading text="Study plan" stackMode="horizontal">
        <CardActionIcons hideEditIcon={! this.props.canEdit}
            onEditClick={this._onEditClick}
            hideDeleteIcon />
      </PageCard.Heading>
      <PageCard.Content className={styles.StudyPlan}>
        <Form>
          {this._renderRadio()}
          {this._renderContent()}
          {this._renderButtons()}
        </Form>
      </PageCard.Content>
    </PageCard>;
  }
}

StudyPlan.propTypes = {
  studentInfo: PropTypes.object,
  idpId: PropTypes.string,
  groupIdpId: PropTypes.string,
  fetchStudyPlanIfNeeded: PropTypes.func,
  fetchStudyPlanCourseIfNeeded: PropTypes.func,
  publishStudyPlan: PropTypes.func,
  group: PropTypes.object,
  studyPlan: PropTypes.object,
  changeMode: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  isInEditMode: PropTypes.bool,
  onComponentMounted: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  const { groupId, idpId } = ownProps;
  const group = state.get('rootReducer').get('groups').get(groupId).data;
  const studyPlan = state.get('rootReducer').get('studyPlan').get(idpId);
  return {
    group,
    studyPlan,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(studyPlanActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StudyPlan);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/StudyPlan/index.jsx